import { Button } from "components/primitives";
import React, { ReactNode } from "react";
import { Modal as BootstrapModal } from "react-bootstrap";
import styled from "styled-components";

import { PreventDragClass } from "../WidgetComponents";

export interface ModalFooterAction {
  key: string;
  textBtn: string;
  action: (data?: any) => void;
  color: string;
  disabled?: boolean;
}

interface ModalProps {
  isOpen: boolean;
  header?: string | ReactNode;
  children: ReactNode;
  footerActions: ModalFooterAction[];
  onClose?: () => void;
  className?: string;
  backdropClassName?: string;
  container?: React.RefObject<any>;
}

export const Modal = (props: ModalProps) => {
  const {
    isOpen,
    header,
    children,
    footerActions,
    className = "",
    container,
    backdropClassName = "",
  } = props;

  return (
    <BootstrapModal
      show={isOpen}
      className={`${className} ${PreventDragClass}`}
      container={container}
      backdropClassName={backdropClassName}
      centered
    >
      {header ? <Header>{header}</Header> : null}

      <BootstrapModal.Body>{children}</BootstrapModal.Body>

      <Footer>
        {footerActions.map(({ key, color, action, textBtn, disabled }) => (
          <FooterButton key={key} color={color} onClick={action} disabled={disabled}>
            {textBtn}
          </FooterButton>
        ))}
      </Footer>
    </BootstrapModal>
  );
};

const Header = styled(BootstrapModal.Header)`
  color: var(--primary);
  font-size: 16pt;
`;

const Footer = styled(BootstrapModal.Footer)`
  justify-content: center;
  border: none;
  margin-top: 30px;
`;

const FooterButton = styled(Button)<{ color: string }>`
  background-color: ${(props) => props.color};
  box-shadow: none;
  color: white;
  width: 20%;
  min-width: 200px;
`;
